import 'uno.css'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

import { apiClient, httpClient } from './axios/http_client'
import ApiInterceptor from './axios/interceptor/ApiInterceptor'
import CommonInterceptor from './axios/interceptor/CommonInterceptor'
import DedupInterceptor from './axios/interceptor/DedupInterceptor'
import { deviceInfo } from './utils/system'

dayjs.extend(utc)
dayjs.extend(timezone)

const commonInterceptor = new CommonInterceptor()
httpClient.instance.interceptors.request.use(commonInterceptor.beforeRequest, commonInterceptor.handleRequestError)
httpClient.instance.interceptors.response.use(commonInterceptor.onResponseSucceed, commonInterceptor.onResponseFailed)

// 请求拦截器先注册的先执行，响应拦截器后注册的先执行
const dedupInterceptor = new DedupInterceptor()
const apiInterceptor = new ApiInterceptor()
apiClient.instance.interceptors.request.use(dedupInterceptor.beforeRequest)
apiClient.instance.interceptors.request.use(apiInterceptor.beforeRequest, apiInterceptor.handleRequestError)
apiClient.instance.interceptors.response.use(apiInterceptor.onResponseSucceed, apiInterceptor.onResponseFailed)
apiClient.instance.interceptors.response.use(dedupInterceptor.onResponseSucceed, dedupInterceptor.onResponseFailed)

if (deviceInfo.value.isMobile) {
  import('./main_mb')
} else {
  import('./main_pc')
}
